// Styles
import "../scss/main.scss";

// Vendor libraries
import "swiper/swiper-bundle.css";
import Swiper from "swiper/bundle";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

// Make libraries globally available
window.Swiper = Swiper;
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

// Import router and page modules
import { router } from "./utils/router.js";
import { common } from "./pages/common.js";
import { ready } from "./utils/dom.js";

// Register all page routes
router.register("common", common);

// Initialize router on DOM ready
ready(() => {
  router.loadEvents();

  // Log confirmation in dev mode
  if (import.meta.env.DEV) {
    console.log("Theme initialized DEV Mode");
  }
});

// Log Vite HMR status in dev mode
if (import.meta.env.DEV) {
  console.log("Vite HMR enabled");
}
